import { useRef, useState } from "react";
import PartnersStrip from "./PartnersStrip";

export default function HeroSection() {
  const desktopRef = useRef<HTMLVideoElement>(null);
  const mobileRef = useRef<HTMLVideoElement>(null);
  const [muted, setMuted] = useState(true);

  const toggleSound = () => {
    const d = desktopRef.current;
    const m = mobileRef.current;
    if (d) d.muted = !muted;
    if (m) m.muted = !muted;
    setMuted(!muted);
  };

  return (
    <section className="relative min-h-[85vh] md:min-h-[90vh] flex items-center mb-0">
      <div className="absolute inset-0 overflow-hidden bg-black">
        {/* Desktop video */}
        <video
          ref={desktopRef}
          src="/SOUAD.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="hidden md:block w-full h-full object-cover"
        />
        {/* Mobile video */}
        <video
          ref={mobileRef}
          src="/VERTICAL.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="md:hidden w-full h-full object-cover"
        />
      </div>

      {/* Sound toggle */}
      <button
        onClick={toggleSound}
        className="absolute top-4 right-4 z-20 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/30 transition-colors"
        aria-label={muted ? "تشغيل الصوت" : "كتم الصوت"}
      >
        <i
          className={`${muted ? "ri-volume-mute-line" : "ri-volume-up-line"} text-lg`}
        />
      </button>

      <PartnersStrip />
    </section>
  );
}
